function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 61.056 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.362 25.5c0 4.142 2.127 7.5 4.75 7.5s4.75-3.358 4.75-7.5-4.75-7.5-4.75-7.5-4.75 3.358-4.75 7.5z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.112 31.6s-1.897 1.4-3 1.4-3-1.4-3-1.4l1 11.4h4z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.112 43c2 1 2 3 3 6-2 0-4-1-5-3-1 2-3 3-5 3 1-3 1-5 3-6zM33.503 35h-5.39M33.579 37h-4.914M33.617 39h-4.914M33.112 41h-4"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -33.612,
  cy: 18.5,
  r: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -28.612,
  cy: 18.5,
  r: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.888 15.543c-2.195-.25-4-2.808-4-6.271 0-5.272 5-7.272 5-7.272-1.692 4.596-.925 6.872 0 9 2.458-1.928 1.5-4.975 2-7 3 4 1 12-3 11.543z",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.745 21.8c1.195 3.245 2.653 5.317 1.845 5.614-.807.297-3.382-.912-4.577-4.157s-.557-7.298.25-7.595c.807-.297 1.287 2.893 2.482 6.138z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 15.543c2.195-.25 4-2.808 4-6.271C43 4 38 2 38 2c1.692 4.596.925 6.872 0 9-2.458-1.928-1.5-4.975-2-7-3 4-1 12 3 11.543z",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.143 21.8c-1.195 3.245-2.653 5.317-1.845 5.614.807.297 3.382-.912 4.577-4.157s.557-7.298-.25-7.595c-.807-.297-1.287 2.893-2.482 6.138z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.888 37.6l-6 .4-2 4M25.888 35h-6l-4 1M24.888 32h-6l-2-4M33 37.6l6 .4 2 4M34 35h6l4 1M35 32h6l2-4"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29.63 24c-.201-2.897.135-5.95-3-8M30.257 24c.202-2.897-.134-5.95 3-8"
})));

var SvgLobster = function SvgLobster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLobster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lobster.6e20d523.svg";
export { ForwardRef as ReactComponent };